import React from 'react';

const GoogleForm = () => {
  return (
    <div>
      <iframe
        src="https://docs.google.com/forms/d/e/1FAIpQLSdeIyDe9sSscaiFvofFWwxS2SM3zQTE_gLDng_QnHlUEIbMtg/viewform"
        title="External Website"
        width="100%"
        height="2500px"
      />
    </div>
  );
};

export default GoogleForm;